/**
 * ShowOnlyFilter — PLP header dropdown with 4 lifecycle views.
 * Mirrors current MRT pattern (Group D brainstorm §8.3).
 *
 * Visible options:
 *   - 'available' (default): display && sellable && pics === 'S'
 *   - 'byRequest':           display && pics === 'N'
 *   - 'older':               display && pics === 'U'
 *   - 'all':                 display === true (any PICS)
 *
 * Style: Sandvik tokens (electric-blue / n3 / n6 / carbon-black),
 * font-sandvik-text, no rounded corners, focus ring on focus.
 * Native <select> for accessibility (4-option pick — no typeahead needed).
 *
 * @param {Object} props
 * @param {'available'|'byRequest'|'older'|'all'} props.value
 * @param {(view: string) => void} props.onChange
 * @param {string} [props.id]            — optional explicit id for the select
 * @param {string} [props.className]     — passthrough wrapper class
 */
export default function ShowOnlyFilter({
  value = 'available',
  onChange,
  id = 'show-only-filter',
  className = '',
}) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <label
        htmlFor={id}
        className="text-xs text-n6 font-sandvik-text whitespace-nowrap"
      >
        Show only:
      </label>
      <select
        id={id}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        className="px-2.5 py-1.5 border border-n3 rounded-none text-sm
                   font-sandvik-text text-carbon-black bg-white
                   focus:outline-none focus:ring-2 focus:ring-electric-blue
                   focus:border-electric-blue"
      >
        <option value="available">Available products</option>
        <option value="byRequest">By request order products</option>
        <option value="older">Older products recommendations</option>
        <option value="all">Show all</option>
      </select>
    </div>
  );
}
